import { Client } from '../models/Client';
import { UpdateClient } from '../models/UpdateClient';

export class ClientToUpdateClientMapper {
  public static convert(client: Client): UpdateClient {
    return new UpdateClient(client);
  }
}
